import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';

import { SgClearFieldComponent, SgClearFieldDirective } from './clear-field/clear-field.component';

const importAndExport = [SgClearFieldComponent, SgClearFieldDirective];

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [importAndExport],
  exports: [importAndExport],
})
export class SgFormFieldModule {}
